/**
 * @generated SignedSource<<ce6ba36ad1a8a6858f414030c937497d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteReportShareInput = {
  id: string;
  reportId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteReportShareMutation$variables = {
  input: DeleteReportShareInput;
};
export type deleteReportShareMutation$data = {
  readonly deleteReportShare: {
    readonly deletedShareId: string | null;
  } | null;
};
export type deleteReportShareMutation = {
  variables: deleteReportShareMutation$variables;
  response: deleteReportShareMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteReportSharePayload",
    "kind": "LinkedField",
    "name": "deleteReportShare",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedShareId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteReportShareMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteReportShareMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "64d5bf1813c9912e25396aca6f4a1bf2",
    "id": null,
    "metadata": {},
    "name": "deleteReportShareMutation",
    "operationKind": "mutation",
    "text": "mutation deleteReportShareMutation(\n  $input: DeleteReportShareInput!\n) {\n  deleteReportShare(input: $input) {\n    deletedShareId\n  }\n}\n"
  }
};
})();

(node as any).hash = "e9cd177ced7333a84a4ae136de8dcb2e";

export default node;
